













































import * as Vue from '@vue/composition-api'
import Stage from '@/components/Stage.vue'
import StageOutput from '@/components/StageOutput.vue'
import OrderCheck from '@/components/OrderCheck.vue'
import BasicDialog from '@/components/BasicDialog.vue'

export default Vue.createComponent({
  name: 'editor',
  components: {
    Stage,
    StageOutput,
    OrderCheck,
    BasicDialog
  },
  props: {
    docId: { type: String }
  },
  setup (props, ctx) {
    const data = Vue.reactive({
      previewDataForOrder: '',
      isOrderChecking: false,
      isOrderCanceling: false,
      isDeleteConfirming: false
    })
    const stage = Vue.ref()
    const stageDesc = Vue.computed(() => {
      const stageComp = stage.value
      return stageComp ? (stageComp as any).stageDescription : undefined
    })

    const docId = Vue.computed(() => {
      return ctx.root.$store.state.doc.docId
    })
    const isOrdered = Vue.computed(() => {
      return ctx.root.$store.state.doc.docOrdered
    })

    const saveDoc = async () => {
      const stageDescObj = stageDesc.value
      const stageComp = stage.value as any
      const thumbData = stageComp ? await stageComp.toImage(0.25) : undefined
      if (stageDescObj) {
        stageDescObj.thumbData = thumbData
        await ctx.root.$store.dispatch('doc/saveDoc', stageDescObj)
      }
    }

    const saveAndExit = async () => {
      if (isOrdered.value) {
        ctx.root.$store.dispatch('doc/closeDoc')
      } else {
        await saveDoc()
        ctx.root.$store.dispatch('doc/closeDoc')
        ctx.root.$store.dispatch('doc/listDocs')
      }
      ctx.root.$router.push('/')
    }

    const saveImage = async () => {
      const stageComp = stage.value as any
      if (stageComp) {
        const data = await stageComp.toImage(0.25)
        console.log(data)
      }
    }

    const checkOrder = async () => {
      await saveDoc()
      const stageComp = stage.value as any
      if (stageComp) {
        data.previewDataForOrder = await stageComp.toImage(0.5, 'png')
        data.isOrderChecking = true
      }
    }

    const closeOrderCheck = () => {
      data.isOrderChecking = false
      data.previewDataForOrder = ''
    }

    const passOrderCheck = (itemType: string) => {
      data.isOrderChecking = false
      data.previewDataForOrder = ''
      if (itemType) {
        ctx.root.$router.push(`/order/${docId.value}/${itemType}`)
      }
    }

    const confirmCancel = () => {
      data.isOrderCanceling = true
    }

    const cancelOrder = async () => {
      data.isOrderCanceling = false
      const isSuccess = await ctx.root.$store.dispatch('doc/cancelOrderDoc', { id: docId.value })
      console.log('isSuccess=', isSuccess)
      if (isSuccess) {
        await ctx.root.$store.dispatch('doc/closeDoc')
        ctx.root.$store.dispatch('doc/listDocs')
        ctx.root.$router.push('/')
      }
    }

    const closeCancelDialog = () => {
      data.isOrderCanceling = false
    }

    const confirmDelete = () => {
      data.isDeleteConfirming = true
    }

    const deleteDoc = async () => {
      data.isDeleteConfirming = false
      const isSuccess = await ctx.root.$store.dispatch('doc/deleteDoc', { id: docId.value })
      if (isSuccess) {
        ctx.root.$router.push('/')
      }
    }

    const closeDeleteDialog = () => {
      data.isDeleteConfirming = false
    }

    // watch stage change on state
    Vue.watch(() => ctx.root.$store.state.doc.stageDescription, (stageDesc, prevStageDesc) => {
      // restore stage //
      const stageComp = stage.value as any
      if (stageComp) {
        stageComp.restoreDescriptopn(stageDesc)
      }
    })

    Vue.onMounted(() => {
      const stDocState = ctx.root.$store.state.doc.docState
      const stDocId = ctx.root.$store.state.doc.docId
      if (stDocId !== props.docId && props.docId) {
        ctx.root.$store.dispatch('doc/openDoc', { id: props.docId })
      }
    })

    return {
      data,
      stage,
      stageDesc,
      isOrdered,
      saveDoc,
      saveAndExit,
      saveImage,
      checkOrder,
      closeOrderCheck,
      passOrderCheck,
      confirmCancel,
      cancelOrder,
      closeCancelDialog,
      confirmDelete,
      deleteDoc,
      closeDeleteDialog
    }
  }
})
